import { ARCHIVE_SEARCH_MODES, ARCHIVE_SEARCH_SORTS, ARCHIVE_SEARCH_URL_MODES } from "./archiveSearchProtocol.js";
import { clampSearchQuery, normalizeSearchText } from "./searchText.js";

const URL_SORTS = new Set([ARCHIVE_SEARCH_SORTS.NEWEST, ARCHIVE_SEARCH_SORTS.RATING]);
const URL_MODES = new Set(Object.values(ARCHIVE_SEARCH_URL_MODES));

function parseTags(params) {
  const tagValues = [
    ...params.getAll("tag"),
    ...String(params.get("tags") || "").split(","),
  ];
  return [...new Set(
    tagValues
      .map((value) => normalizeSearchText(value).replace(/\s+/g, "-"))
      .filter(Boolean)
  )];
}

export function parseArchiveSearchUrl(search = "") {
  const params = search instanceof URLSearchParams
    ? search
    : new URLSearchParams(String(search || "").replace(/^\?/, ""));
  const query = clampSearchQuery(params.get("q") || "").trim();
  const mode = URL_MODES.has(params.get("mode")) ? params.get("mode") : ARCHIVE_SEARCH_MODES.LEXICAL;
  const sort = URL_SORTS.has(params.get("sort")) ? params.get("sort") : ARCHIVE_SEARCH_SORTS.RELEVANCE;

  return {
    query,
    mode,
    sort,
    selectedTags: parseTags(params),
  };
}

export function serializeArchiveSearchUrl(state = {}) {
  const params = new URLSearchParams();
  const query = clampSearchQuery(state.query || "").trim();
  if (query) params.set("q", query);
  const selectedTags = Array.isArray(state.selectedTags) ? state.selectedTags.filter(Boolean) : [];
  for (const tag of selectedTags) {
    params.append("tag", tag);
  }
  if (state.mode === ARCHIVE_SEARCH_MODES.SEMANTIC && query) {
    params.set("mode", ARCHIVE_SEARCH_MODES.SEMANTIC);
  }
  if (URL_SORTS.has(state.sort)) {
    params.set("sort", state.sort);
  }
  const value = params.toString();
  return value ? `?${value}` : "";
}
